import { SearchProvider } from "~/types/i18n";

export function useSearchProvider() {
  const { store } = useI18nExtend();

  const provider = computed<SearchProvider>(
    () => store.value.searchProvider ?? SearchProvider.klevu,
  );

  const isMagento = computed<boolean>(
    () => provider.value === SearchProvider.magento,
  );

  return { provider, isMagento };
}
